<template>
    <div class="blur-wrap w-full h-1000 lg:j-h-600 relative" :class="{ 'mb-300 lg:j-mb-0': isLogin }">
        <!-- 未登录 -->
        <div v-if="!isLogin" class="w-full h-full mx-auto relative">
            <img
                class="lazyload block lg:hidden w-full h-full object-cover absolute left-0 top-0 z-0"
                data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/banner-MB_631537e4-8d9d-42b1-a1ee-0693f9ed5ae0.jpg?v=1729244169"
                alt=""
            >
            <img
                class="lazyload hidden lg:block w-full h-full object-cover absolute left-0 top-0 z-0"
                data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/banner-PC_d4e4b60c-296c-4a01-825f-2a85037b554b.jpg?v=1729244169"
                alt=""
            >
            <div class="w-full lg:j-w-1180 h-full mx-auto pt-55 lg:j-pt-150 lg:j-pl-140 relative">
                <h2 class="banner-title" v-html="t('member_index.banner.title')"></h2>
                <p class="w-full min-h-44 px-30 text-28 leading-44 lg:j-min-h-32 lg:max-w-[55%] lg:px-0 lg:j-text-24 lg:j-leading-32 Poppins-Light font-semibold text-black/60 mt-20 lg:j-mt-20 text-center lg:text-left" v-html="t('member_index.banner.description')"></p>
                <div class="flex items-center justify-center lg:justify-start gap-x-20 lg:j-gap-x-30 mt-20 lg:j-mt-30">
                    <button
                        class="button-base bg-primary text-white"
                        @click.prevent="acrossDomainJump()"
                    >{{ t('member_index.common.quick_login').toUpperCase() }}</button>
                </div>
            </div>
        </div>

        <!-- 已登录 -->
        <div v-else class="w-full h-full mx-auto relative">
            <img
                class="lazyload block lg:hidden w-full h-full object-cover absolute left-0 top-0 z-0"
                data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/banner-MB_631537e4-8d9d-42b1-a1ee-0693f9ed5ae0.jpg?v=1729244169"
                alt=""
            >
            <img
                class="lazyload hidden lg:block w-full h-full object-cover absolute left-0 top-0 z-0"
                data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/banner-PC_d4e4b60c-296c-4a01-825f-2a85037b554b.jpg?v=1729244169"
                alt=""
            >
            <div class="w-full lg:j-w-1180 h-full mx-auto pt-55 lg:j-pt-150 relative">
                <h2 class="banner-title lg:j-pl-80" v-html="t('member_index.banner.title')"></h2>
                <p class="w-full min-h-44 px-30 lg:j-pl-80 text-28 leading-44 lg:min-h-32 lg:max-w-[55%] lg:px-0 lg:j-text-24 lg:j-leading-32 Poppins-Light font-semibold text-black/60 mt-20 lg:j-mt-20 text-center lg:text-left" v-html="t('member_index.banner.description')"></p>
                <div class="amount-balance">
                    <div class="w-full h-full bg-white opacity-20 blur-[10px] absolute left-0 top-0 right-0 bottom-0 z-0"></div>
                    <div class="w-full h-full flex-center flex-col lg:flex-between lg:flex-row lg:j-pl-80 lg:j-pr-48 relative">
                        <div class="flex gap-20 lg:j-gap-x-100">
                            <span class="min-w-250 lg:min-w-auto flex-center flex-col">
                                <em class="amount-text text-black lg:text-black">{{amountBalance.balancePoint}}</em>
                                <i class="amount-text-weak text-black/60 lg:text-black/60">{{ t('member_index.banner.points_balance') }}</i>
                            </span>
                            <span class="min-w-250 lg:min-w-auto flex-center flex-col">
                                <em class="amount-text text-black/30 lg:text-black/30">{{amountBalance.comingSoonPoint}}</em>
                                <i class="amount-text-weak text-black/30 lg:text-black/30">{{ t('member_index.banner.coming_soon') }}</i>
                            </span>
                        </div>
                        <div class="flex flex-wrap mt-60 lg:j-mt-0 gap-30 lg:j-gap-38">
                            <button class="button-activity" @click="showRewardsModal">{{ t('member_index.banner.my_rewards') }}</button>
                            <button class="button-activity" @click="showActivityModal">{{ t('member_index.banner.my_activity') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- ReWards 弹窗 -->
    <RewardsModal ref="rewardsModal" :isLogin="props.isLogin" :points="amountBalance.balancePoint"/>

    <!-- Activity 弹窗 -->
    <ActivityModal ref="activityModal" :title="t('member_index.banner.my_activity')"/>

</template>

<script setup>
    import { pullBalanceAmount } from '@a/index';
    import RewardsModal from './banner/RewardsModal.vue';
    import ActivityModal from './banner/ActivityModal.vue';
    import { cookie } from "@u/common";
    import { gaPushDataLayer } from '@/utils/ga.js'
    import { useStore } from 'vuex';

    const router = useRouter();
    const { t } = useI18n();
    const store = useStore();
    const userInfo = computed(() => store.getters.userInfo);

    const props = defineProps({
        isLogin: Boolean,
    })


    // 跨域名 跳转
    const acrossDomainJump = () => {
        const params = {
            button_name: t('member_index.common.quick_login')
        }
        gaPushDataLayer( params)
        if(window.jackeryLoginApp) {
            window.jackeryLoginApp.modalLogin({
                return_url: `${window.location.origin}${window.location.pathname}`, 
                register_act: 'MEM-Register'
            })     
        }
        return
    }

    const amountBalance = reactive({
        balancePoint: 0,
        comingSoonPoint: 0,
    })

    const getAmountBalance = async () => {
        const { balancePoint, comingSoonPoint} = await pullBalanceAmount()
        amountBalance.balancePoint = balancePoint
        amountBalance.comingSoonPoint = comingSoonPoint
    }

    onMounted(() => {
        if(props.isLogin) {
            getAmountBalance()

            // 监听抽奖活动完成，更新积分
            document.addEventListener('luckyDrawDone', (event) => {
                if (event.detail.status) {
                    getAmountBalance()
                }
            })
        }
    })

    // Rewards 弹窗
    const rewardsModal = ref(null);
    const showRewardsModal = () => {
        const params = {
            jackery_id: userInfo.value.userName,
            button_name: t('member_index.banner.my_rewards')
        }
        gaPushDataLayer( params)
        rewardsModal.value?.openModal()
    }
    // Activity 弹窗
    const activityModal = ref(null)
    const showActivityModal = () => {
        const params = {
            jackery_id: userInfo.value.userName,
            button_name: t('member_index.banner.my_activity')
        }
        gaPushDataLayer( params)
        activityModal.value?.openModal()
    }
</script>
<style scoped>
    .banner-title {
    @apply
        w-full min-h-96 text-88 leading-96 Poppins-Semibold font-semibold text-black text-center lg:(j-min-h-75 j-text-72 j-leading-75 text-left)
    }
    .button-base {
    @apply
        min-w-240 h-80 lg:w-auto lg:j-min-w-154 lg:j-px-24 lg:j-h-56 flex-center rounded-full text-28 lg:j-text-20
        Poppins-Semibold font-semibold cursor-pointer hover:(bg-primary text-white) transition-all duration-300
    }
    @media screen and (max-width: 1023px){
        .button-base{
            min-width: 52vw;
        }
    }
    .amount-balance {
        @apply
        w-610 min-h-320 pt-60 pb-40 px-40 absolute left-70 -bottom-300 rounded-70 border border-solid border-white/50 overflow-hidden z-1
        shadow-[0px_0px_16px_rgba(0,0,0,0.05)]
        lg:(w-full j-min-h-160 j-left-0 j-bottom-0 j-rounded-16 j-pt-35 pb-0 px-0) !lg:rounded-b-0
        backdrop-blur-32 backdrop-saturate-100
        bg-white/10 [&:not(backdrop-filter:blur())]:bg-white/50
    }
    .amount-text {
    @apply
        text-56 leading-56 Poppins-Semibold font-semibold lg:(j-text-48 j-leading-48)
    }
    .amount-text-weak {
    @apply
        text-24 Poppins-Medium font-medium lg:(j-text-20 j-leading-20 j-mt-15)
    }
    .button-activity {
    @apply
        flex-center flex-auto min-w-250 max-h-80 px-36 py-25 bg-primary Poppins-Semibold font-semibold
        rounded-full text-32 text-white cursor-pointer
        lg:(j-min-w-157 j-px-22 j-py-16 j-rounded-26 j-text-20 j-leading-20)
    }
</style>
